const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

/**
 * A-Z jump-scroll sidebar. Only meaningful for name-based sorts (first
 * or last name) — the parent decides whether to render it. Letters with
 * no contacts are dimmed and disabled; the active letter is highlighted.
 *
 * Stateless — the parent owns `activeLetter` + `onLetterClick`.
 */
export default function SearchAZSidebar({
  contactsByGroup,
  activeLetter,
  onLetterClick,
}) {
  return (
    <div className="pinch-fixed w-8 flex flex-col items-center sticky top-0 h-fit pt-1" data-testid="az-sidebar">
      {ALPHABET.map((letter) => {
        const hasContacts = contactsByGroup[letter]?.length > 0;
        return (
          <button
            key={letter}
            onClick={() => { if (hasContacts) onLetterClick(letter); }}
            disabled={!hasContacts}
            className={`text-xs font-bold py-[3px] w-full text-center transition-colors rounded-sm ${
              activeLetter === letter
                ? 'text-white bg-nav-blue'
                : hasContacts
                  ? 'text-nav-blue hover:bg-nav-blue/10'
                  : 'text-slate-300 cursor-default'
            }`}
            style={{ minHeight: 22 }}
            data-testid={`az-${letter}`}
          >
            {letter}
          </button>
        );
      })}
    </div>
  );
}
